import React from 'react';
import { useTranslation, withTranslation } from "react-i18next"
import { Grid } from '@mui/material/'
import '../../utils/common.scss';
import SETTINGS from '../../utils/constants';
import FacebookIcon from '@mui/icons-material/Facebook';
import InstagramIcon from '@mui/icons-material/Instagram';
import TwitterIcon from '@mui/icons-material/Twitter';
import './contactUs.scss'
import qrCode from "../../misc/qrCode.jpg"

const ContactUs=()=>{
    const {t, i18n} = useTranslation();
    const translateArray = t('contactUs', {returnObjects: true})
    const isChinese = i18n.language === 'cn'

    const directToSocialMedia=(url)=>{
        window.open(url)
    }

    return(
        <Grid container direction='column' align='center' justifyContent='center'>
            <Grid item className='general-title'>{translateArray?.title}</Grid>
            {translateArray?.content?.map((item, index)=>{
                return <Grid item key={index} className='general-text' style={{color: SETTINGS.DEEP_COLOR, lineHeight:'36px'}}>{item}</Grid>
            })}
            {isChinese?
                <Grid sx={{display: {xs: 'block', sm:'none'}}}>
                    <img src={qrCode} alt="qrCode" style={{maxWidth: '200px'}} />
                </Grid>
                :
                null
            }
            <Grid item>
                <FacebookIcon className='iconStyle' onClick={()=>directToSocialMedia(SETTINGS.FACEBOOK_LINK)}/>
                <InstagramIcon className='iconStyle' onClick={()=>directToSocialMedia(SETTINGS.INSTAGRAM_LINK)}/>
                <TwitterIcon className='iconStyle' onClick={()=>directToSocialMedia(SETTINGS.TWITTER_LINK)}/>
            </Grid>
        </Grid>
    )
}

export default withTranslation()(ContactUs)